// API Configuration
// VITE_API_URL is set at build time by CI for each environment.
// Fallback to localhost for local development only.
const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:8080';

// Health check function
async function checkApiHealth(): Promise<boolean> {
  try {
    const response = await fetch(`${API_BASE_URL}/api/health`);
    const isHealthy = response.ok;
    console.log(`[API] Health check ${isHealthy ? 'passed' : 'failed'}`);
    return isHealthy;
  } catch (error) {
    console.error('[API] Health check failed:', error);
    return false;
  }
}

export { API_BASE_URL, checkApiHealth };

// URL Builder Functions
export const buildChatUrl = (path: string): string => {
  return `${API_BASE_URL}${path}`;
};

// API Response Types
export interface ApiResponse {
  success: boolean;
  message?: string;
  user?: unknown;
  token?: string;
  articles?: unknown[];
  article?: unknown;
  // MFA fields
  requiresMFA?: boolean;
  userId?: string;
  email?: string;
  name?: string;
  // Lockout fields
  lockedUntil?: string;
  remainingSeconds?: number;
  // Verification field
  requiresVerification?: boolean;
  // Other response fields
  contacts?: unknown[];
  contactCount?: number;
  ticketNumber?: string;
}

// API Error Types
export class ApiError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'ApiError';
  }
}